module.exports = __webpack_public_path__ + "store/img/leash-placeholder.a2684810.svg";